import FactDetail from './FactDetail';

export default FactDetail;

